import { Link } from "@/lib/router-compat";
import { Instagram, Linkedin, Mail, Phone, Youtube } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#08080A] pt-20 pb-8 border-t border-white/10">
      <div className="container mx-auto px-6 max-w-[1200px]">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 mb-16">
          <div className="col-span-2 md:col-span-1">
            <span className="text-[#FAFAFA] font-bold text-2xl tracking-tight block mb-4">
              crecelocal.
            </span>
            <p className="text-[#A1A1AA] text-[15px] leading-relaxed max-w-xs">
              Buenos Aires, Argentina.
            </p>
          </div>

          <div className="col-span-1">
            <h3 className="text-[#FAFAFA] font-medium mb-6 text-[15px]">
              Qué hacemos
            </h3>
            <ul className="space-y-4">
              {[
                { name: "Sitio Web Funcional", href: "/que-hacemos/sitio-web" },
                {
                  name: "Embudo de 5 Estrellas",
                  href: "/que-hacemos/embudo-5-estrellas",
                },
                {
                  name: "Campañas de WhatsApp",
                  href: "/que-hacemos/campanas-whatsapp",
                },
                {
                  name: "Inbox Unificado",
                  href: "/que-hacemos/inbox-unificado",
                },
                { name: "SEO Local", href: "/que-hacemos/seo-local" },
                {
                  name: "Seguimiento Automático",
                  href: "/que-hacemos/seguimiento-automatico",
                },
                { name: "Agente IA", href: "/que-hacemos/agente-ia" },
              ].map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-[#A1A1AA] hover:text-[#FAFAFA] transition-colors text-[14px]"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-1">
            <h3 className="text-[#FAFAFA] font-medium mb-6 text-[15px]">
              Para quién
            </h3>
            <ul className="space-y-4">
              {[
                {
                  name: "Empresas de servicios",
                  href: "/empresas-de-servicios",
                },
                {
                  name: "Distribuidoras y mayoristas",
                  href: "/distribuidoras",
                },
                { name: "Todos los rubros", href: "/#para-quien-es" },
                { name: "Testimonios", href: "/testimonios" },
              ].map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-[#A1A1AA] hover:text-[#FAFAFA] transition-colors text-[14px]"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-2 md:col-span-1">
            <h3 className="text-[#FAFAFA] font-medium mb-6 text-[15px]">
              La empresa
            </h3>
            <ul className="space-y-4">
              {[
                { name: "Nosotros", href: "/nosotros" },
                { name: "Trabajos", href: "/trabajos" },
                { name: "Precios", href: "/precios" },
                {
                  name: "Generador Link WhatsApp",
                  href: "/generador-link-whatsapp",
                },
              ].map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-[#A1A1AA] hover:text-[#FAFAFA] transition-colors text-[14px]"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contacto */}
        <div className="flex flex-col md:flex-row items-start md:items-center gap-6 mb-12 pb-12 border-b border-white/10">
          <a
            href="mailto:info@crecelocal.com"
            className="text-[#A1A1AA] hover:text-[#FAFAFA] transition-colors text-[15px] flex items-center gap-3"
          >
            <Mail className="w-4 h-4" />
            info@crecelocal.com
          </a>
          <a
            href="https://wa.me/5491123729528?text=Vengo%20de%20la%20web%20y%20tengo%20una%20duda"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              import("@/lib/analytics").then(({ trackWhatsApp }) =>
                trackWhatsApp(
                  "Footer - WhatsApp",
                  "https://wa.me/5491123729528?text=Vengo%20de%20la%20web%20y%20tengo%20una%20duda",
                ),
              )
            }
            className="text-[#A1A1AA] hover:text-[#FAFAFA] transition-colors text-[15px] flex items-center gap-3"
          >
            <Phone className="w-4 h-4" />
            +54 9 11 2372 9528
          </a>
        </div>

        {/* Legal + social */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            {[
              { name: "Términos", href: "/terminos" },
              { name: "Privacidad", href: "/privacidad" },
              { name: "Reembolsos", href: "/reembolso" },
              { name: "Tus datos", href: "/tus-datos" },
            ].map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-[#9CA3AF] hover:text-[#FAFAFA] transition-colors text-[13px]"
              >
                {link.name}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-6">
            <a
              href="https://www.youtube.com/@CreceLocal"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Canal de YouTube de CreceLocal"
              className="text-[#9CA3AF] hover:text-[#FAFAFA] transition-colors"
            >
              <Youtube className="w-5 h-5" aria-hidden="true" />
            </a>
            <a
              href="https://www.instagram.com/crecelocal/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Perfil de Instagram de CreceLocal"
              className="text-[#9CA3AF] hover:text-[#FAFAFA] transition-colors"
            >
              <Instagram className="w-5 h-5" aria-hidden="true" />
            </a>
            <a
              href="https://www.linkedin.com/company/crecelocal/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Página de LinkedIn de CreceLocal"
              className="text-[#9CA3AF] hover:text-[#FAFAFA] transition-colors"
            >
              <Linkedin className="w-5 h-5" aria-hidden="true" />
            </a>
          </div>
        </div>

        <p className="text-[#9CA3AF] font-mono text-[12px] tracking-wider uppercase mt-8 text-center md:text-left">
          © 2026 CreceLocal. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
};
